import NewsletterForm from '../Client/NewsLetterForm';

export default function NewsletterSection() {
  return (
    <section className="w-full">
        <div className="flex items-center justify-center w-full px-5 h-[400px] relative"
            style={{
                backgroundImage: "url('/images/office.jpg')",
                backgroundAttachment: "fixed",
                backgroundPosition: "center center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="absolute inset-0 bg-blue-900/30" />

            <div className="flex items-center justify-center w-full md:w-[60%] bg-white/70 backdrop-blur-sm py-6 md:py-12 px-6 sm:px-10 md:px-36 rounded-xl z-10">
                <div className="flex flex-col items-center justify-center gap-5 w-full">
                
                    <div className="flex flex-col items-center justify-center px-2 sm:px-10 text-center">
                        <h3 className="text-[20px] sm:text-[22px] md:text-[30px] uppercase font-semibold">
                        Subscribe to our newsletter
                        </h3>
                        <p className="text-[13px] sm:text-[14px] md:text-[16px] w-full md:w-[70%] mt-1">
                        Stay informed with the latest legal news, in-depth expert
                        analysis, and important firm announcements.
                        </p>
                    </div>

                    <NewsletterForm />
                </div>
            </div>

        </div>

    </section>
  );
}